import { createSlice } from "@reduxjs/toolkit";
const initialState = {
    latestEntropyBps: 0,
    data: [],
    timeWindow: 60
};
const entropyConsumptionSlice = createSlice({
    name: "entropyConsumption",
    initialState,
    reducers: {
        setLatestEntropy (state, action) {
            state.latestEntropyBps = action.payload.latestEntropyBps;
        },
        setTimeWindow (state, action) {
            state.timeWindow = action.payload;
        },
        setHistoricalData (state, action) {
            const { key, data } = action.payload;
            state[key] = data;
        },
        addEntropyConsumptionDataPoint (state) {
            const now = Math.floor(Date.now() / 1000) * 1000;
            const oldestPoint = now - state.timeWindow * 60 * 1000;
            const filtered = state.data.filter((d)=>d.x >= oldestPoint);
            if (state.latestEntropyBps != null) {
                const newPoint = {
                    x: now,
                    y: state.latestEntropyBps
                };
                state.data = [
                    ...filtered,
                    newPoint
                ];
            } else {
                state.data = filtered;
            }
        }
    }
});
export const { setLatestEntropy, setTimeWindow, setHistoricalData, addEntropyConsumptionDataPoint } = entropyConsumptionSlice.actions;
export default entropyConsumptionSlice.reducer;
